<script>
	import ms from 'milliseconds'
	import { get, set } from 'money-clip'
	import Skycons from '../util/skycons.js'

	const { boostRestUrl } = window

	let weatherData = null

	function getWeather() {
		get('weather', {
			maxAge: ms.minutes(5),
		}).then(cachedWeather => {
			if (cachedWeather) {
				weatherData = cachedWeather
				return
			}
			fetch(`${boostRestUrl}?action=get_weather`)
				.then(res => res.json())
				.then(res => {
					weatherData = res
					set('weather', weatherData)
				})
		})
	}

	function makeIcon() {
		var skycons = new Skycons({
			monochrome: false,
		})
		skycons.add('wb_icon', weatherData.icon)
		skycons.play()
	}
</script>

<div class="weather-box shadow-box" class:loaded={!!weatherData} use:getWeather>
	{#if weatherData}
		<div class="wb-icon">
			<canvas id="wb_icon" width="55" height="55" use:makeIcon />
		</div>
		<div>
			<p class="wb-temp">
				Currently:
				<span>
					{@html `${weatherData.temp}°<sup>F</sup>`}
				</span>
			</p>
			<p class="wb-hl">
				High: {weatherData.dayHigh}° | Low: {weatherData.dayLow}°
			</p>
			<p class="wb-summary">{weatherData.summary}</p>
		</div>
	{:else}
		<div class="weather-loading">
			<p>Loading weather...</p>
		</div>
	{/if}
</div>
